module.exports = __webpack_public_path__ + "img/qilin-stage4-blink.37a1f62e.png";